import './ox-scene-property.js'

import { LitElement, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('ox-scene-handler')
export default class OxSceneHandler extends LitElement {
  @property({ type: String }) type!: string
  @property({ type: Object }) model!: {
    type: Object
    notify: true
  }

  render() {
    return html` <slot select="ox-scene-property"></slot> `
  }

  connectedCallback() {
    super.connectedCallback()

    let model: any = {
      type: this.type
    }

    model = Array.from(this.querySelectorAll('ox-scene-property')).reduce((model: any, property: any) => {
      const name = property.getAttribute('name')
      const value = property.getAttribute('value')

      if (name) {
        model[name] = value
      }

      return model
    }, model)

    model.__host__ = this

    this.model = model
  }
}
